/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingMelcoModelsCustomWarning,
    TrackingMelcoModelsCustomWarningFromJSON,
    TrackingMelcoModelsCustomWarningFromJSONTyped,
    TrackingMelcoModelsCustomWarningToJSON,
    TrackingTrackingModelsLegacyLogEntry,
    TrackingTrackingModelsLegacyLogEntryFromJSON,
    TrackingTrackingModelsLegacyLogEntryFromJSONTyped,
    TrackingTrackingModelsLegacyLogEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry
 */
export interface TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry {
    /**
     * 
     * @type {Array<TrackingTrackingModelsLegacyLogEntry>}
     * @memberof TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry
     */
    list: Array<TrackingTrackingModelsLegacyLogEntry>;
    /**
     * 
     * @type {Array<TrackingMelcoModelsCustomWarning>}
     * @memberof TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry
     */
    warning_list?: Array<TrackingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry
     */
    total: number;
}

export function TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryFromJSON(json: any): TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry {
    return TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryFromJSONTyped(json, false);
}

export function TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(TrackingTrackingModelsLegacyLogEntryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(TrackingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntryToJSON(value?: TrackingMelcoModelsGenericList1TrackingModelsLegacyLogEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(TrackingTrackingModelsLegacyLogEntryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(TrackingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


